import React from "react";
import { Button, Group, Select } from "@mantine/core";

import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";
import {
  Subtree,
  SubtreeBody,
  SubtreeHeader,
} from "@piqnt/runtime-core/react/Subtree";
import { DraftIcon } from "@piqnt/runtime-core/react/Icon";

import { SpaceContext } from "../space";

interface CreateBodyInfoProps {
  title?: string;
}

const bodyTypes = [
  { type: "dynamic", name: "Dynamic" },
  { type: "static", name: "Static" },
  { type: "kinematic", name: "Kinematic" },
];

const staticShapes = [
  { type: "circle", name: "Circle" },
  { type: "box", name: "Box" },
  { type: "polygon", name: "Polygon" },
  { type: "chain", name: "Chain" },
  { type: "edge", name: "Edge" },
  { type: "bezier", name: "Bezier Curve" },
];

export const BodyCreate: React.FC<CreateBodyInfoProps> = (props) => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const editable = context.editable.value;

  const [bodyType, setBodyType] = React.useState(null as string);
  const [shapeType, setShapeType] = React.useState(null as string);

  const createDraft = React.useCallback(() => {
    if (!bodyType || !shapeType) return;
    emit("body-fixture-draft", {
      body: { type: bodyType },
      fixture: { shape: { type: shapeType } },
    });
  }, [bodyType, shapeType]);

  if (!editable) return null;

  return (
    <Subtree open>
      <SubtreeHeader>{props.title ?? "createBody"}</SubtreeHeader>
      <SubtreeBody>
        <Group gap={4}>
          <Select
            placeholder="..."
            onChange={(type) => setBodyType(type)}
            data={bodyTypes.map((bodyType) => ({
              value: bodyType.type,
              label: bodyType.name,
            }))}
            size="xs"
            w={95}
          />
          <Select
            placeholder="..."
            onChange={(type) => setShapeType(type)}
            data={staticShapes.map((shapeType) => ({
              value: shapeType.type,
              label: shapeType.name,
            }))}
            size="xs"
            w={90}
          />
          <Button
            disabled={!bodyType || !shapeType}
            size="xs"
            variant="default"
            onClick={createDraft}
          >
            <DraftIcon />
          </Button>
        </Group>
      </SubtreeBody>
    </Subtree>
  );
};
